module.exports={ALL_COUNTRIES:"All countries"};